import { roles, tierObject } from '@constants/index';
import { RootState, Tier } from '@utils/types';
import { Popover } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import { useSelector } from 'react-redux';

const ProfilePopover = () => {
  const { t: translate } = useTranslation();
  const { externalId, fullName, segmentCode, segmentName, mobile, tier } =
    useSelector((state: RootState) => state.user);
  const tierValue: Tier = tierObject[tier as keyof typeof tierObject];

  return (
    <Popover
      aria-labelledby="area-popover"
      content={
        <div className="shadow-custom w-[336px] rounded-[10px] bg-white p-4">
          <h2 className="mb-4 font-semibold">Profile</h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col">
              <h3 className="mb-1 text-xs text-gray-500">Dealer Id</h3>
              <p className="text-sm">{externalId}</p>
            </div>
            <div className="flex flex-col">
              <h3 className="mb-1 text-xs text-gray-500">Dealer Name</h3>
              <p className="text-sm">{fullName}</p>
            </div>
            <div className="flex flex-col">
              <h3 className="mb-1 text-xs text-gray-500">Category</h3>
              <p className="text-sm">
                {segmentCode === roles.nonVPP
                  ? segmentName
                  : translate(tierValue.title)}
              </p>
            </div>
            <div className="flex flex-col">
              <h3 className="mb-1 text-xs text-gray-500">Contact Number</h3>
              <p className="text-sm">{mobile}</p>
            </div>
          </div>

          <div>
            <p className="mt-9 text-sm text-grey-reward">
              To make any changes contact{' '}
              <span className="text-black underline">+91 22 6212 5000</span>
            </p>
          </div>
        </div>
      }
    >
      <span className="m-auto">
        <HiOutlineDotsVertical className="my-auto ml-2 h-7 w-7" />
      </span>
    </Popover>
  );
};

export default ProfilePopover;
